import { Component } from '@angular/core';
import { JeevesInvoiceTableComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'sjoborg-invoice-table',
    templateUrl: './sjoborg-invoice-table.component.html',
    styleUrls: ['./sjoborg-invoice-table.component.scss'],
    standalone: false
})
export class SjoborgInvoiceTableComponent extends JeevesInvoiceTableComponent {}
